module.exports = __webpack_public_path__ + "static/media/choose_class_7_decoration.c587912d.svg";